import React, { useState, useEffect, useRef } from 'react';
import api from '../services/api';

export default function Conexoes() {
  const [instancias, setInstancias] = useState([
    { id: 'campanhas', label: 'Campanhas', icon: 'ti-speakerphone', status: 'carregando' },
    { id: 'comercial', label: 'Comercial', icon: 'ti-building-store', status: 'carregando' },
  ]);
  const [configs,     setConfigs]     = useState({});
  const [modalAberto, setModalAberto] = useState(null);
  const [editando,    setEditando]    = useState(null);

  useEffect(() => { carregarTudo(); }, []);

  async function carregarTudo() {
    try {
      const [statusRes, configRes] = await Promise.all([
        api.get('/conexoes/status'),
        api.get('/conexoes/config'),
      ]);
      setConfigs(configRes.data);
      setInstancias(prev => prev.map(inst => ({
        ...inst,
        ...(statusRes.data[inst.id] || {}),
      })));
    } catch {}
  }

  const badge = (status) => {
    if (status === 'connected')    return { bg: '#dcfce7', text: '#14532d', label: 'Conectado' };
    if (status === 'connecting')   return { bg: '#fef9c3', text: '#713f12', label: 'Conectando...' };
    if (status === 'disconnected') return { bg: '#fee2e2', text: '#7f1d1d', label: 'Desconectado' };
    return { bg: '#f1f5f9', text: '#475569', label: 'Verificando...' };
  };

  return (
    <div style={s.page}>
      <div style={s.header}>
        <div style={s.title}><i className="ti ti-plug-connected" style={{ fontSize: 18 }} /> Conexões WhatsApp</div>
        <div style={s.sub}>Gerencie os números e tokens conectados à plataforma</div>
      </div>

      <div style={s.grid}>
        {instancias.map(inst => {
          const b   = badge(inst.status);
          const cfg = configs[inst.id] || {};
          return (
            <div key={inst.id} style={s.card}>
              <div style={s.cardHeader}>
                <div style={s.cardIcon}>
                  <i className={`ti ${inst.icon}`} style={{ fontSize: 22, color: 'var(--green)' }} />
                </div>
                <div style={{ flex: 1 }}>
                  <div style={s.cardTitle}>{inst.label}</div>
                  <div style={s.cardSub}>Instância: {cfg.instancia || inst.id}</div>
                </div>
                <span style={{ ...s.badge, background: b.bg, color: b.text }}>
                  <span style={{ width: 6, height: 6, borderRadius: '50%', background: b.text, display: 'inline-block', marginRight: 5 }} />
                  {b.label}
                </span>
              </div>

              {inst.telefone && (
                <div style={s.tel}>
                  <i className="ti ti-device-mobile" style={{ fontSize: 13 }} />
                  +{inst.telefone}
                </div>
              )}

              {/* Config resumida */}
              <div style={s.configBox}>
                <div style={s.configRow}>
                  <span style={s.configLabel}>URL do servidor</span>
                  <span style={s.configVal}>{cfg.uazapi_url || '—'}</span>
                </div>
                <div style={s.configRow}>
                  <span style={s.configLabel}>Token</span>
                  <span style={s.configVal}>{cfg.token_mascarado || '—'}</span>
                </div>
              </div>

              <div style={s.cardActions}>
                {inst.status === 'connected' ? (
                  <button style={{ ...s.btn, ...s.btnDanger }} onClick={() => desconectar(inst.id, carregarTudo)}>
                    <i className="ti ti-plug-x" /> Desconectar
                  </button>
                ) : (
                  <button style={{ ...s.btn, ...s.btnPrimary }} onClick={() => setModalAberto(inst.id)}>
                    <i className="ti ti-qrcode" /> Conectar via QR
                  </button>
                )}
                <button style={s.btn} onClick={() => setEditando(inst.id)}>
                  <i className="ti ti-settings" /> Configurar
                </button>
                <button style={s.btn} onClick={carregarTudo}>
                  <i className="ti ti-refresh" />
                </button>
              </div>
            </div>
          );
        })}
      </div>

      {modalAberto && (
        <ModalQR instId={modalAberto} onClose={() => { setModalAberto(null); carregarTudo(); }} />
      )}

      {editando && (
        <ModalConfig
          instId={editando}
          config={configs[editando] || {}}
          onClose={() => { setEditando(null); carregarTudo(); }}
        />
      )}
    </div>
  );
}

function ModalConfig({ instId, config, onClose }) {
  const [url,       setUrl]       = useState(config.uazapi_url || '');
  const [token,     setToken]     = useState('');
  const [instancia, setInstancia] = useState(config.instancia || instId);
  const [salvando,  setSalvando]  = useState(false);
  const [salvo,     setSalvo]     = useState(false);
  const [erro,      setErro]      = useState('');

  async function salvar() {
    if (!url || !instancia) return setErro('URL e instância são obrigatórios.');
    setSalvando(true); setErro('');
    try {
      await api.put('/conexoes/config', {
        numero: instId,
        uazapi_url: url,
        token: token || undefined,
        instancia,
      });
      setSalvo(true);
      setTimeout(onClose, 1500);
    } catch (err) {
      setErro(err.response?.data?.erro || 'Erro ao salvar.');
    }
    setSalvando(false);
  }

  return (
    <div style={s.modalBg} onClick={onClose}>
      <div style={s.modal} onClick={e => e.stopPropagation()}>
        <div style={s.modalHead}>
          <span style={{ fontWeight: 600 }}>Configurar — {instId === 'campanhas' ? 'Campanhas' : 'Comercial'}</span>
          <button style={s.modalClose} onClick={onClose}><i className="ti ti-x" /></button>
        </div>
        <div style={{ padding: 24, display: 'flex', flexDirection: 'column', gap: 14 }}>
          <Field label="URL do servidor uazapi">
            <input style={s.input} value={url} onChange={e => setUrl(e.target.value)} placeholder="https://meuservidor.uazapi.com" />
          </Field>
          <Field label="Token da instância">
            <input style={s.input} type="password" value={token} onChange={e => setToken(e.target.value)}
              placeholder={config.token_mascarado || 'Cole o novo token aqui'} />
            <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 4 }}>Deixe em branco para manter o token atual</div>
          </Field>
          <Field label="Nome da instância">
            <input style={s.input} value={instancia} onChange={e => setInstancia(e.target.value)} placeholder="campanhas" />
          </Field>

          {erro && <div style={{ padding: '8px 12px', background: '#fef2f2', borderRadius: 8, fontSize: 12, color: '#dc2626' }}>{erro}</div>}
          {salvo && <div style={{ padding: '8px 12px', background: '#f0fdf4', borderRadius: 8, fontSize: 12, color: '#14532d' }}>✅ Salvo com sucesso!</div>}

          <button style={{ ...s.btn, ...s.btnPrimary, justifyContent: 'center' }} onClick={salvar} disabled={salvando}>
            {salvando ? 'Salvando...' : 'Salvar configurações'}
          </button>
        </div>
      </div>
    </div>
  );
}

function ModalQR({ instId, onClose }) {
  const [etapa,      setEtapa]      = useState('qr');
  const [qrcode,     setQrcode]     = useState('');
  const [pareamento, setPareamento] = useState('');
  const [telefone,   setTelefone]   = useState('');
  const [status,     setStatus]     = useState('aguardando');
  const [erro,       setErro]       = useState('');
  const intervalRef = useRef(null);

  useEffect(() => { iniciarConexao(); return () => clearInterval(intervalRef.current); }, []);

  async function iniciarConexao(phone = null) {
    setErro(''); setQrcode(''); setPareamento('');
    try {
      await api.post('/conexoes/conectar', { instancia: instId, telefone: phone });
      poolStatus();
    } catch { setErro('Erro ao iniciar conexão.'); }
  }

  function poolStatus() {
    clearInterval(intervalRef.current);
    intervalRef.current = setInterval(async () => {
      try {
        const { data } = await api.get('/conexoes/status/' + instId);
        const st = data.status;
        const conectado = st === true || st?.connected === true || st === 'connected';
        if (conectado) { setStatus('connected'); clearInterval(intervalRef.current); setTimeout(onClose, 2000); }
        else if (data.qrcode)      setQrcode(data.qrcode);
        else if (data.pairingCode) setPareamento(data.pairingCode);
      } catch {}
    }, 3000);
  }

  return (
    <div style={s.modalBg} onClick={onClose}>
      <div style={s.modal} onClick={e => e.stopPropagation()}>
        <div style={s.modalHead}>
          <span style={{ fontWeight: 600 }}>Conectar — {instId === 'campanhas' ? 'Campanhas' : 'Comercial'}</span>
          <button style={s.modalClose} onClick={onClose}><i className="ti ti-x" /></button>
        </div>
        <div style={{ padding: 24 }}>
          {status === 'connected' ? (
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 10, padding: 32 }}>
              <i className="ti ti-circle-check" style={{ fontSize: 40, color: '#22c55e' }} />
              <div style={{ fontWeight: 600 }}>Conectado com sucesso!</div>
            </div>
          ) : (
            <>
              <div style={{ display: 'flex', gap: 4, marginBottom: 20, borderBottom: '1px solid var(--border)', paddingBottom: 0 }}>
                {['qr', 'pareamento'].map(t => (
                  <button key={t} style={{ ...s.tab, ...(etapa === t ? s.tabActive : {}) }}
                    onClick={() => { setEtapa(t); if (t === 'qr') iniciarConexao(); }}>
                    {t === 'qr' ? 'QR Code' : 'Código de pareamento'}
                  </button>
                ))}
              </div>

              {etapa === 'qr' ? (
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 20 }}>
                  {qrcode ? (
                    <img src={qrcode} alt="QR" style={{ width: 220, height: 220, borderRadius: 12 }} />
                  ) : (
                    <div style={{ width: 220, height: 220, borderRadius: 12, background: 'var(--bg-app)', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', border: '2px dashed var(--border)' }}>
                      <i className="ti ti-loader-2" style={{ fontSize: 32, animation: 'spin 1s linear infinite' }} />
                      <div style={{ fontSize: 12, color: 'var(--text-muted)', marginTop: 8 }}>Gerando QR Code...</div>
                    </div>
                  )}
                  <div style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 8 }}>
                    {['Abra o WhatsApp no celular', 'Toque em Menu → Aparelhos conectados', 'Toque em Conectar um aparelho', 'Aponte a câmera para o QR Code'].map((t, i) => (
                      <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 10, fontSize: 12, color: 'var(--text-secondary)' }}>
                        <span style={{ width: 22, height: 22, borderRadius: '50%', background: 'var(--green)', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11, fontWeight: 700, flexShrink: 0 }}>{i+1}</span>
                        {t}
                      </div>
                    ))}
                  </div>
                </div>
              ) : (
                <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                  <div style={{ fontSize: 13, color: 'var(--text-secondary)' }}>Digite o número para receber o código:</div>
                  <input type="tel" placeholder="5511999999999" value={telefone} onChange={e => setTelefone(e.target.value.replace(/\D/g,''))} style={s.input} />
                  <button style={{ ...s.btn, ...s.btnPrimary, justifyContent: 'center' }} onClick={() => iniciarConexao(telefone)} disabled={telefone.length < 11}>
                    Gerar código
                  </button>
                  {pareamento && (
                    <div style={{ marginTop: 12, padding: 16, background: 'var(--bg-app)', borderRadius: 10, textAlign: 'center' }}>
                      <div style={{ fontSize: 11, color: 'var(--text-muted)', marginBottom: 6 }}>Código de pareamento:</div>
                      <div style={{ fontSize: 28, fontWeight: 700, letterSpacing: 6 }}>{pareamento}</div>
                    </div>
                  )}
                </div>
              )}
              {erro && <div style={{ marginTop: 12, padding: '10px 14px', background: '#fef2f2', borderRadius: 8, fontSize: 12, color: '#dc2626' }}>{erro}</div>}
            </>
          )}
        </div>
      </div>
      <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
    </div>
  );
}

function Field({ label, children }) {
  return (
    <div>
      <label style={{ display: 'block', fontSize: 11, fontWeight: 500, color: 'var(--text-secondary)', marginBottom: 5 }}>{label}</label>
      {children}
    </div>
  );
}

async function desconectar(instId, callback) {
  if (!window.confirm('Desconectar este número?')) return;
  try { await api.post('/conexoes/desconectar', { instancia: instId }); callback(); } catch {}
}

const s = {
  page:    { flex: 1, overflowY: 'auto', padding: 28, background: 'var(--bg-app)' },
  header:  { marginBottom: 24 },
  title:   { fontSize: 18, fontWeight: 600, color: 'var(--text-primary)', display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 },
  sub:     { fontSize: 13, color: 'var(--text-muted)' },
  grid:    { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(380px, 1fr))', gap: 16 },
  card:    { background: '#fff', border: '1px solid var(--border)', borderRadius: 14, padding: 20 },
  cardHeader: { display: 'flex', alignItems: 'center', gap: 12, marginBottom: 14 },
  cardIcon:{ width: 44, height: 44, borderRadius: 12, background: 'var(--bg-app)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 },
  cardTitle:{ fontSize: 15, fontWeight: 600, color: 'var(--text-primary)' },
  cardSub: { fontSize: 11, color: 'var(--text-muted)', marginTop: 2 },
  badge:   { display: 'inline-flex', alignItems: 'center', fontSize: 11, fontWeight: 500, padding: '4px 10px', borderRadius: 99, flexShrink: 0 },
  tel:     { fontSize: 13, color: 'var(--text-secondary)', marginBottom: 12, display: 'flex', alignItems: 'center', gap: 6 },
  configBox: { background: 'var(--bg-app)', borderRadius: 8, padding: 12, marginBottom: 14 },
  configRow: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 },
  configLabel: { fontSize: 11, color: 'var(--text-muted)', fontWeight: 500 },
  configVal: { fontSize: 11, color: 'var(--text-secondary)', maxWidth: 220, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
  cardActions: { display: 'flex', gap: 8, flexWrap: 'wrap' },
  btn:     { display: 'inline-flex', alignItems: 'center', gap: 6, padding: '8px 14px', borderRadius: 9, border: '1px solid var(--border)', background: 'transparent', fontSize: 12, fontWeight: 500, color: 'var(--text-secondary)', cursor: 'pointer' },
  btnPrimary: { background: 'var(--green)', borderColor: 'var(--green)', color: '#fff' },
  btnDanger:  { borderColor: '#fca5a5', color: '#dc2626' },
  modalBg: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 200 },
  modal:   { background: '#fff', borderRadius: 18, width: 440, maxHeight: '90vh', overflowY: 'auto', boxShadow: '0 24px 64px rgba(0,0,0,0.2)' },
  modalHead: { padding: '16px 20px', borderBottom: '1px solid var(--border)', display: 'flex', alignItems: 'center', justifyContent: 'space-between', position: 'sticky', top: 0, background: '#fff' },
  modalClose: { border: 'none', background: 'none', fontSize: 20, color: 'var(--text-muted)', cursor: 'pointer' },
  tab:     { padding: '8px 14px', border: 'none', background: 'none', fontSize: 12, fontWeight: 500, color: 'var(--text-muted)', cursor: 'pointer', borderBottom: '2px solid transparent', marginBottom: -1 },
  tabActive:{ color: 'var(--green)', borderBottomColor: 'var(--green)' },
  input:   { width: '100%', padding: '10px 14px', borderRadius: 9, border: '1px solid var(--border)', background: 'var(--bg-app)', fontSize: 13, color: 'var(--text-primary)', fontFamily: 'var(--font-sans)' },
};